import { render, staticRenderFns } from "./aeWorkspace.vue?vue&type=template&id=09a1fa6c&scoped=true&"
import script from "./aeWorkspace.vue?vue&type=script&lang=js&"
export * from "./aeWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./aeWorkspace.vue?vue&type=style&index=0&lang=css&"
import style1 from "./aeWorkspace.vue?vue&type=style&index=1&id=09a1fa6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1fa6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a1fa6c')) {
      api.createRecord('09a1fa6c', component.options)
    } else {
      api.reload('09a1fa6c', component.options)
    }
    module.hot.accept("./aeWorkspace.vue?vue&type=template&id=09a1fa6c&scoped=true&", function () {
      api.rerender('09a1fa6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/aeWorkspace.vue"
export default component.exports